import React from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Divider from '@material-ui/core/Divider';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';

import BarChart from '@material-ui/icons/BarChart';
import Home from '@material-ui/icons/Home';
import People from '@material-ui/icons/People';
import Person from '@material-ui/icons/Person';
import PieChart from '@material-ui/icons/PieChart';
import Place from '@material-ui/icons/Place';
import TableChart from '@material-ui/icons/TableChart';
import LabelImportant from '@material-ui/icons/LabelImportant';

import AuthenticationStore from '../stores/AuthenticationStore';
import UIStore from '../stores/UIStore';

const styles = theme => ({
  asideBar: {
    [theme.breakpoints.up('md')]: {
      height: 'calc(100% - 128px)',
    },
    [theme.breakpoints.down('md')]: {
      height: 'calc(100% - 32px)',
    },
    backgroundColor: theme.palette.background.default,
    position: 'fixed',
    paddingTop: '32px',
    width: '285px',
    zIndex: 999,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  headerBar: {
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    textIndent: '8px',
    zIndex: 2,
  },
  titleStyle: {
    fontWeight: 'bold',
    overflow: 'hidden',
    transition: 'width 0.5s ease-in-out',
  },
  menuItem: {
    borderLeft: '5px solid transparent',
  },
  menuItemSelected: {
    backgroundColor: 'transparent !important',
    borderLeft: `5px solid ${theme.palette.primary.main}`,
    '& $primary, & $icon': {
      color: theme.palette.primary.main,
    },
  },
  primary: {},
  icon: {},
  closed: { transform: 'translate(-290px, 0px)' },
});

class AsideBar extends React.Component {
  navigate = url => {
    let { history, width } = this.props;
    let force = width === 'md' || width === 'lg' || width === 'xl';
    history.push(url);
    if (!force || url.startsWith('/mapas')) {
      UIStore.asideOpen(force);
    }
  };

  render() {
    let { classes, location } = this.props;
    let telas = [{ label: 'Apresentação', leftIcon: <Home />, to: '/' }];
    if (
      AuthenticationStore.me.cargo &&
      AuthenticationStore.me.cargo.proporcional
    ) {
      telas.push({
        label: 'Gráfico de Vagas',
        leftIcon: <BarChart />,
        to: '/proporcional/vagas',
      });
      telas.push({
        label: 'Distribuição de Vagas',
        leftIcon: <TableChart />,
        to: '/proporcional/distribuicao',
      });
      telas.push({
        label: 'Índice de Intenção de Votos',
        leftIcon: <TableChart />,
        to: '/proporcional/intencao',
      });
      telas.push({
        label: 'Índice de Indecisos',
        leftIcon: <PieChart />,
        to: '/proporcional/indecisos',
      });
      telas.push({
        label: 'Votação dos Candidatos',
        leftIcon: <TableChart />,
        to: '/proporcional/votacao',
      });
    }
    if (
      AuthenticationStore.me.cargo &&
      !AuthenticationStore.me.cargo.proporcional
    ) {
      telas.push({
        label: 'Gráfico Espontâneo',
        leftIcon: <BarChart />,
        to: '/majoritario/espontaneo',
      });
      telas.push({
        label: 'Gráfico Estimulado',
        leftIcon: <BarChart />,
        to: '/majoritario/estimulado',
      });
      telas.push({
        label: 'Votos Válidos',
        leftIcon: <BarChart />,
        to: '/majoritario/validos',
      });
      telas.push({
        label: 'Índice de Indecisos',
        leftIcon: <PieChart />,
        to: '/majoritario/indecisos',
      });
      telas.push({
        label: 'Projeção de Votos',
        leftIcon: <TableChart />,
        to: '/majoritario/projecao',
      });
    }
    if (AuthenticationStore.me.cargo) {
      telas.push({
        label: 'Base Municípios',
        leftIcon: <Place />,
        to: '/mapas/municipios',
      });
      telas.push({
        label: 'Base Microrregiões',
        leftIcon: <Place />,
        to: '/mapas/microregioes',
      });
      telas.push({
        label: 'Base Mesorregiões',
        leftIcon: <Place />,
        to: '/mapas/mesoregioes',
      });
    }
    if (AuthenticationStore.hasRole('ADMIN')) {
      telas.push({});
      telas.push({
        label: 'Usuários',
        leftIcon: <Person />,
        to: '/usuarios',
      });
      telas.push({
        label: 'Candidatos',
        leftIcon: <People />,
        to: '/candidatos',
      });
      telas.push({
        label: 'Rodadas',
        leftIcon: <LabelImportant />,
        to: '/rodadas',
      });
    }
    return (
      <div
        className={classNames(classes.asideBar, {
          [classes.closed]: !UIStore.asideOpened && !UIStore.forceAside,
        })}
      >
        {telas.map(
          (t, i) =>
            t.to ? (
              <MenuItem
                key={i}
                selected={location.pathname === t.to}
                classes={{
                  root: classes.menuItem,
                  selected: classes.menuItemSelected,
                }}
                onClick={() => this.navigate(t.to)}
              >
                <ListItemIcon className={classes.icon}>
                  {t.leftIcon}
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.primary }}
                  inset
                  primary={t.label}
                />
              </MenuItem>
            ) : (
              <Divider key={i} />
            )
        )}
      </div>
    );
  }
}

export default withRouter(withWidth()(withStyles(styles)(observer(AsideBar))));



// WEBPACK FOOTER //
// ./src/components/AsideBar.js